import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Grid, Box, Paper, IconButton, Tooltip, Avatar } from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Helper from "../../common/Helper";

const useStyles = makeStyles((theme) => ({
  root: {
    border: "1px solid #cacaca",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    margin: "0 0 -1px 0",
    alignItems: "center",
    "&:nth-child(odd)": {
      background: "#f8f8f8",
    },
    [theme.breakpoints.down("sm")]: {
      flexWrap: "nowrap",
    },
  },
  logoAndTeams: {
    display: "flex",
    padding: theme.spacing(0, 2),
    alignItems: "center",
  },
  items: {
    padding: theme.spacing(1),
  },
  loginButton: {
    marginRight: theme.spacing(2),
  },
  content: {
    alignItems: "center",
    width: "100%",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    display: "flex",
    flexGrow: 1,
    "&:hover": {
      backgroundColor: "#f7f6f6",
    },
  },
  smBlue: {
    marginLeft: "16px",
    width: 32,
    height: 32,
    color: theme.palette.getContrastText("#0c2c75"),
    backgroundColor: "#0c2c75",
    position: "relative",
    overflow: "hidden",
    borderRadius: "50%",
  },
  headShotImage: {
    width: "100%",
    height: "auto",
    marginTop: "auto",
  },
}));

const UserViewList = (props) => {
  const classes = useStyles();

  const setLoggedInUser = () => {
    props.setUserPersonate(props.userData);
    props.setIsLoading(true);
  };
  return (
    // <Grid container className={classes.root}>
    <>
      <Grid
        item
        md={3}
        sm={3}
        className={classes.items}
        key={props.userData.loginID}
      >
        <Paper
          elevation={2}
          className={classes.content}
          onClick={setLoggedInUser}
          sx={{ cursor: "pointer" }}
        >
          <Tooltip
            title={`${props.userData.lastName} ${props.userData.firstName}`}
          >
            <Avatar className={classes.smBlue}>
              {props.userData.headShotURL ? (
                <img
                  alt="user"
                  className={classes.headShotImage}
                  src={props.userData.headShotUrl}
                />
              ) : (
                <Typography variant="caption">
                  {props.userData.firstName ? (
                    Helper.GetNameInitials(
                      `${props.userData.lastName} ${props.userData.firstName}`
                    )
                  ) : (
                    <AccountCircleIcon />
                  )}
                </Typography>
              )}
            </Avatar>
          </Tooltip>
          <Box
            component="div"
            flexGrow={1}
            sx={{ Width: "100%", overflow: "hidden" }}
          >
            <Typography color="primary" className={classes.logoAndTeams}>
              <label style={{ padding: "0 8px", cursor: "pointer" }}>
                {props.userData.lastName}, {props.userData.firstName}
              </label>
            </Typography>
            <Typography
              color="secondary"
              variant="caption"
              className={classes.logoAndTeams}
              noWrap
            >
              <label style={{ padding: "0 8px", cursor: "pointer" }}>
                <Tooltip title={`${props.userData.appRoles[0]}`}>
                  {props.userData.userType}({props.userData.appRoles[0]})
                </Tooltip>
              </label>
            </Typography>
          </Box>
          <IconButton
            variant="contained"
            className={classes.loginButton}
            color="primary"
          >
            <LockOpenIcon size="small" />
          </IconButton>
          {/* <Button>Set LoggedIn User</Button> */}
        </Paper>
      </Grid>
    </>
    // </Grid>
  );
};

export default UserViewList;
